<main class="pv2-additional-catalog">
  <header class="pv2-additional-catalog__header">
    <div class="pv2-additional-catalog__heading">
      <button type="button" class="pv2-additional-catalog__back" (click)="goToProducts()" aria-label="Voltar para produtos">
        <span class="fa fa-arrow-left"></span>
      </button>
      <div>
        <span class="pv2-additional-catalog__eyebrow">Catálogo</span>
        <h1>Adicionais</h1>
        <p>Crie uma vez, vincule a vários produtos e mantenha as opções em um só lugar.</p>
      </div>
    </div>

    <button type="button" class="pv2-additional-catalog__primary" (click)="openProductPicker()" [disabled]="!canEdit">
      <span class="fa fa-plus"></span>
      Novo adicional
    </button>
  </header>

  <section class="pv2-additional-catalog__stats" *ngIf="!loading">
    <button type="button" [class.is-active]="filter === 'all'" (click)="setFilter('all')">
      <strong>{{ items.length }}</strong>
      <span>Todos</span>
    </button>
    <button type="button" [class.is-active]="filter === 'exclusive'" (click)="setFilter('exclusive')">
      <strong>{{ exclusiveCount }}</strong>
      <span>Exclusivos</span>
    </button>
    <button type="button" [class.is-active]="filter === 'shared'" (click)="setFilter('shared')">
      <strong>{{ sharedCount }}</strong>
      <span>Compartilhados</span>
    </button>
    <button type="button" [class.is-active]="filter === 'unlinked'" (click)="setFilter('unlinked')">
      <strong>{{ unlinkedCount }}</strong>
      <span>Sem vínculo</span>
    </button>
  </section>

  <section class="pv2-additional-catalog__toolbar" *ngIf="!loading">
    <label class="pv2-additional-catalog__search">
      <span class="fa fa-search"></span>
      <input [(ngModel)]="search" type="search" placeholder="Buscar adicional ou produto vinculado">
    </label>
    <span class="pv2-additional-catalog__result-count">
      {{ filteredItems.length }} {{ filteredItems.length === 1 ? 'resultado' : 'resultados' }}
    </span>
  </section>

  <section class="pv2-additional-catalog__loading" *ngIf="loading">
    <span class="fa fa-spinner fa-spin"></span>
    <p>Carregando adicionais...</p>
  </section>

  <section class="pv2-additional-catalog__error" *ngIf="!loading && errorMessage">
    <span class="fa fa-exclamation-circle"></span>
    <div>
      <strong>Não foi possível abrir os adicionais</strong>
      <p>{{ errorMessage }}</p>
      <button type="button" (click)="load()">Tentar novamente</button>
    </div>
  </section>

  <section class="pv2-additional-list" *ngIf="!loading && !errorMessage && filteredItems.length">
    <div class="pv2-additional-list__head" aria-hidden="true">
      <span>Adicional</span>
      <span>Regra</span>
      <span>Vínculos</span>
      <span>Opções</span>
      <span></span>
    </div>

    <article class="pv2-additional-row"
             *ngFor="let item of filteredItems; trackBy: trackByAdditional"
             tabindex="0"
             role="button"
             (click)="openAdditional(item)"
             (keydown.enter)="openAdditional(item)">
      <div class="pv2-additional-row__identity">
        <span class="pv2-additional-row__icon" [class.is-shared]="item.sharedCount > 1">
          <i class="fa" [ngClass]="item.type === 'single' ? 'fa-dot-circle-o' : 'fa-check-square-o'"></i>
        </span>
        <div>
          <h2>{{ item.name }}</h2>
          <span class="pv2-additional-row__badge" [class.is-optional]="!item.required">
            {{ requirementLabel(item) }}
          </span>
        </div>
      </div>

      <div class="pv2-additional-row__cell" data-label="Regra">
        <strong>{{ item.description }}</strong>
        <span>{{ item.type === 'single' ? 'Escolha única' : item.type === 'multipleRepeat' ? 'Múltipla com repetição' : 'Escolha múltipla' }}</span>
      </div>

      <div class="pv2-additional-row__cell" data-label="Vínculos">
        <strong class="pv2-additional-row__scope"
                [class.is-exclusive]="item.sharedCount === 1"
                [class.is-shared]="item.sharedCount > 1"
                [class.is-unlinked]="item.sharedCount === 0">
          {{ usageLabel(item) }}
        </strong>
        <span>{{ usageSupport(item) }}</span>
      </div>

      <div class="pv2-additional-row__options" data-label="Opções">
        <strong>{{ item.optionsCount }}</strong>
        <span>{{ item.optionsCount === 1 ? 'opção' : 'opções' }}</span>
      </div>

      <span class="pv2-additional-row__chevron fa fa-chevron-right" aria-hidden="true"></span>
    </article>
  </section>

  <section class="pv2-additional-catalog__empty" *ngIf="!loading && !errorMessage && !filteredItems.length">
    <span class="fa fa-list-ul"></span>
    <h2>{{ items.length ? 'Nenhum adicional encontrado' : 'Crie seu primeiro adicional' }}</h2>
    <p>{{ items.length ? 'Ajuste a busca ou selecione outro filtro.' : 'Escolha um produto para cadastrar o grupo e depois reutilize-o em todo o catálogo.' }}</p>
    <button type="button" *ngIf="!items.length" (click)="openProductPicker()" [disabled]="!canEdit">Novo adicional</button>
  </section>
</main>

<div class="pv2-product-picker__overlay" *ngIf="productPickerOpen" (click)="closeProductPicker()"></div>
<aside class="pv2-product-picker" *ngIf="productPickerOpen" role="dialog" aria-modal="true" aria-labelledby="pv2-product-picker-title">
  <header>
    <div>
      <span>Primeiro passo</span>
      <h2 id="pv2-product-picker-title">Em qual produto deseja criar?</h2>
      <p>O adicional nasce vinculado a este produto e depois pode ser compartilhado.</p>
    </div>
    <button type="button" (click)="closeProductPicker()" aria-label="Fechar"><span class="fa fa-times"></span></button>
  </header>

  <label class="pv2-product-picker__search">
    <span class="fa fa-search"></span>
    <input [(ngModel)]="productSearch" type="search" placeholder="Buscar produto">
  </label>

  <div class="pv2-product-picker__list">
    <button type="button" *ngFor="let product of filteredProducts; trackBy: trackByProduct" (click)="createForProduct(product)">
      <span class="pv2-product-picker__avatar">{{ product.emoji || '🍽️' }}</span>
      <span class="pv2-product-picker__product">
        <strong>{{ product.name }}</strong>
        <small>{{ product.category }}</small>
      </span>
      <span class="fa fa-chevron-right"></span>
    </button>
    <p class="pv2-product-picker__empty" *ngIf="!filteredProducts.length">Nenhum produto encontrado.</p>
  </div>
</aside>
